/**
 * Poptoons · Outlet · "Mi selección".
 *
 * Usa el carrito real de Shopify (/cart.js) pero con una regla: en el outlet no
 * conviven productos de la tienda regular. Un producto es del outlet cuando su
 * product_type es "Outlet" O está en la colección `outlet` (se lee una vez de
 * /collections/outlet/products.json, porque /cart.js no expone tags: así basta con
 * ponerle el tag al producto). Antes de agregar una pieza:
 *   - si el carrito trae productos regulares → diálogo "se paga aparte"; al aceptar
 *     se ponen esas líneas en 0 (/cart/update.js) y recién se agrega la pieza;
 *   - si no → se agrega directo y se abre el panel.
 * El panel pinta las líneas del outlet, permite cambiar cantidad / quitar y manda al
 * checkout de siempre (form POST /cart con name=checkout).
 */
(function () {
  'use strict';
  if (window.__ptOutletInit) return;
  window.__ptOutletInit = true;

  var cfg = window.ptOutlet || {};
  var routes = cfg.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update' };
  var OUTLET_TYPE = 'outlet';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  var panel = $('[data-pt-out-cart]');
  var overlay = $('.js-overlay');
  var confirmBox = $('[data-pt-out-confirm]');
  var toastEl = $('[data-pt-out-toast]');
  var lastFocus = null;
  var busy = false;

  // Ids de producto de la colección outlet (tag `outlet`). Se cargan una vez; si la
  // carga falla, queda el tipo "Outlet" como señal de respaldo.
  var outletIds = {};
  var outletIdsReady = fetch((cfg.collectionUrl || '/collections/outlet') + '/products.json?limit=250', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : { products: [] }; })
    .then(function (j) { (j.products || []).forEach(function (p) { outletIds[p.id] = true; }); })
    .catch(function () {});

  function isOutlet(item) {
    return outletIds[item.product_id] === true ||
      String(item.product_type || '').trim().toLowerCase() === OUTLET_TYPE;
  }

  // Formato de moneda del shop ("S/ {{amount}}") sin depender de main.js.
  function money(cents) {
    var fmt = cfg.moneyFormat || 'S/ {{amount}}';
    var n = (Number(cents) || 0) / 100;
    var out;
    if (fmt.indexOf('amount_no_decimals') !== -1) out = Math.round(n).toLocaleString('es-PE');
    else if (fmt.indexOf('amount_with_comma_separator') !== -1) out = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    else out = n.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, out);
  }

  function jsonFetch(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, opts.headers || {});
    opts.credentials = 'same-origin';
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || 'Error'); e.data = j; throw e; }
        return j;
      });
    });
  }

  function getCart() {
    return outletIdsReady.then(function () { return jsonFetch(routes.cart + '.js'); });
  }

  function toast(msg, kind) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.className = 'pt-out-toast' + (kind ? ' pt-out-toast--' + kind : '');
    toastEl.hidden = false;
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.hidden = true; }, 3200);
  }

  // ---- panel ----
  function openPanel() {
    if (!panel) return;
    lastFocus = document.activeElement;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    document.body.classList.add('pt-out-cart-open');
    $$('[data-pt-out-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { var c = $('[data-pt-out-close]', panel); if (c) c.focus(); }, 50);
  }

  function closePanel() {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.classList.remove('pt-out-cart-open');
    $$('[data-pt-out-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function render(cart) {
    if (!panel) return;
    var items = cart.items.filter(isOutlet);
    var regular = cart.items.filter(function (i) { return !isOutlet(i); });
    var count = items.reduce(function (n, i) { return n + i.quantity; }, 0);
    var subtotal = items.reduce(function (n, i) { return n + i.final_line_price; }, 0);

    $$('[data-pt-out-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });

    var list = $('[data-pt-out-items]', panel);
    var empty = $('[data-pt-out-empty]', panel);
    var foot = $('[data-pt-out-foot]', panel);
    var notice = $('[data-pt-out-notice]', panel);

    list.innerHTML = items.map(function (i) {
      var img = i.featured_image && i.featured_image.url
        ? i.featured_image.url.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x160$1$2') : '';
      // /cart.js no dice cuánto stock queda: el "+" de una pieza única falla con
      // un toast claro ("No hay más unidades") en vez de esconder el control.
      var qtyCtl = '<div class="pt-out-line__qty">' +
            '<button type="button" data-pt-out-qty-change="-1" data-key="' + i.key + '" aria-label="Quitar una">−</button>' +
            '<span>' + i.quantity + '</span>' +
            '<button type="button" data-pt-out-qty-change="1" data-key="' + i.key + '" aria-label="Agregar una">+</button>' +
          '</div>';
      return '<li class="pt-out-line" data-key="' + i.key + '">' +
        (img ? '<img class="pt-out-line__img" src="' + img + '" alt="" width="64" height="64" loading="lazy">' : '<span class="pt-out-line__img"></span>') +
        '<div class="pt-out-line__main">' +
          '<a class="pt-out-line__title" href="' + i.url + '">' + escapeHtml(i.product_title) + '</a>' +
          (i.sku ? '<span class="pt-out-line__sku">' + escapeHtml(i.sku) + '</span>' : '') +
          qtyCtl +
        '</div>' +
        '<div class="pt-out-line__side">' +
          '<span class="pt-out-line__price">' + money(i.final_line_price) + '</span>' +
          '<button type="button" class="pt-out-line__remove" data-pt-out-remove data-key="' + i.key + '">Quitar</button>' +
        '</div>' +
      '</li>';
    }).join('');

    empty.hidden = items.length > 0;
    foot.hidden = items.length === 0;
    $('[data-pt-out-subtotal]', panel).textContent = money(subtotal);

    if (regular.length) {
      var rc = regular.reduce(function (n, i) { return n + i.quantity; }, 0);
      notice.textContent = 'Tienes ' + rc + (rc === 1 ? ' producto' : ' productos') + ' de la tienda en tu carrito. Se apartan cuando agregues algo del outlet: el outlet se paga en un pedido aparte.';
      notice.hidden = false;
    } else {
      notice.hidden = true;
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function refresh() { return getCart().then(render); }

  // ---- confirmación "se paga aparte" ----
  function askConfirm(regularCount) {
    return new Promise(function (resolve) {
      if (!confirmBox) { resolve(window.confirm('El outlet se paga en un pedido aparte. ¿Apartamos los productos de la tienda de tu carrito?')); return; }
      var text = $('[data-pt-out-confirm-text]', confirmBox);
      text.textContent = 'Tu carrito tiene ' + regularCount + (regularCount === 1 ? ' producto' : ' productos') + ' de la tienda regular. Para agregar esta pieza del outlet, ese carrito se aparta.';
      confirmBox.hidden = false;
      var ok = $('[data-pt-out-confirm-ok]', confirmBox);
      var cancel = $('[data-pt-out-confirm-cancel]', confirmBox);
      function done(v) { confirmBox.hidden = true; ok.onclick = cancel.onclick = null; document.removeEventListener('keydown', esc); resolve(v); }
      function esc(e) { if (e.key === 'Escape') done(false); }
      ok.onclick = function () { done(true); };
      cancel.onclick = function () { done(false); };
      document.addEventListener('keydown', esc);
      setTimeout(function () { ok.focus(); }, 30);
    });
  }

  // ---- agregar ----
  function add(variantId, qty, btn) {
    if (busy) return;
    busy = true;
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }

    getCart().then(function (cart) {
      var regular = cart.items.filter(function (i) { return !isOutlet(i); });
      if (!regular.length) return true;
      var rc = regular.reduce(function (n, i) { return n + i.quantity; }, 0);
      return askConfirm(rc).then(function (yes) {
        if (!yes) return false;
        var updates = {};
        regular.forEach(function (i) { updates[i.key] = 0; });
        return jsonFetch(routes.cartUpdate + '.js', { method: 'POST', body: JSON.stringify({ updates: updates }) }).then(function () { return true; });
      });
    }).then(function (proceed) {
      if (!proceed) return null;
      return jsonFetch(routes.cartAdd + '.js', { method: 'POST', body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] }) })
        .then(function () { return refresh(); })
        .then(function () { openPanel(); toast('Agregado a tu selección', 'ok'); });
    }).catch(function (err) {
      var msg = (err && err.message) || '';
      if (/stock|inventory|disponib|available|sold out|agotad/i.test(msg)) msg = 'Ya no queda stock de esta pieza. Alguien se te adelantó.';
      else if (!msg) msg = 'No se pudo agregar. Intenta de nuevo.';
      toast(msg, 'err');
      refresh();
    }).then(function () {
      busy = false;
      if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
    });
  }

  function change(key, qty) {
    if (busy) return;
    busy = true;
    jsonFetch(routes.cartChange + '.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) })
      .then(render)
      .catch(function (err) {
        var msg = (err && err.message) || 'No se pudo actualizar.';
        if (/stock|inventory|disponib|available|agotad/i.test(msg)) msg = 'No hay más unidades de esta pieza.';
        toast(msg, 'err');
        return refresh();
      })
      .then(function () { busy = false; });
  }

  // ---- eventos ----
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pt-out-add], [data-pt-out-open], [data-pt-out-close], [data-pt-out-remove], [data-pt-out-qty-change]');
    if (!t) {
      if (overlay && e.target === overlay && panel && panel.classList.contains('is-open')) closePanel();
      return;
    }
    if (t.hasAttribute('data-pt-out-add')) {
      e.preventDefault();
      var scope = t.closest('[data-pt-out-buy]') || document;
      var sel = $('[data-pt-out-qty]', scope);
      var qty = sel ? Math.max(1, parseInt(sel.value, 10) || 1) : 1;
      add(t.getAttribute('data-variant-id'), qty, t);
    } else if (t.hasAttribute('data-pt-out-open')) {
      e.preventDefault();
      refresh().then(openPanel);
    } else if (t.hasAttribute('data-pt-out-close')) {
      closePanel();
    } else if (t.hasAttribute('data-pt-out-remove')) {
      change(t.getAttribute('data-key'), 0);
    } else if (t.hasAttribute('data-pt-out-qty-change')) {
      var line = t.closest('.pt-out-line');
      var cur = parseInt($('.pt-out-line__qty span', line).textContent, 10) || 1;
      change(t.getAttribute('data-key'), Math.max(0, cur + parseInt(t.getAttribute('data-pt-out-qty-change'), 10)));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) closePanel();
  });

  // El precio del botón sigue a la cantidad elegida en la ficha.
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-pt-out-qty]');
    if (!sel) return;
    var scope = sel.closest('[data-pt-out-buy]');
    var price = scope && $('[data-pt-out-price]', scope);
    if (price) price.textContent = money(Number(price.getAttribute('data-unit')) * (parseInt(sel.value, 10) || 1));
  });

  // Estado inicial del contador (el header lo pinta Liquid; aquí se confirma con /cart.js).
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();
